import { a1 as attr, a2 as stringify, a0 as store_get, a3 as unsubscribe_stores } from "./index.js";
import { w as writable } from "./exports.js";
const loading = writable(true);
function Loading($$payload) {
  var $$store_subs;
  $$payload.out += `<div${attr("class", `w-full h-full fixed top-0 left-0 bg-gray-950 flex items-center justify-center transition-all duration-300 ${stringify(store_get($$store_subs ??= {}, "$loading", loading) ? "opacity-100" : "opacity-0 pointer-events-none")} z-50 svelte-kp5wrn`)}><span class="loader svelte-kp5wrn"></span></div>`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
}
export {
  Loading as L
};
